import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '@ls-commons/utils';

@Pipe({
  name: 'flagLanguage',
  standalone: true,
})
export class FlagLanguagePipe implements PipeTransform {
  constructor(private utilsService: UtilsService) {}

  transform(value: string): unknown {
    const iso = this.utilsService.getLanguage(value)?.iso2.toLowerCase();
    return `flag flag-${iso}`;
  }
}
